import { render, staticRenderFns } from "./multiline_input.vue?vue&type=template&id=56c71057&scoped=true&"
import script from "./multiline_input.vue?vue&type=script&lang=ts&"
export * from "./multiline_input.vue?vue&type=script&lang=ts&"
import style0 from "./multiline_input.vue?vue&type=style&index=0&id=56c71057&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c71057",
  null
  
)

export default component.exports